import Vue from "vue";
import ElectronAppService from "@/services/ElectronAppService";
import { backendSocket, electronSocket } from "@/main.js";
const io = require("socket.io-client");

const SOCKET_ALERT_THROTTLE_MS = 30000;
const ELECTRON_RECONNECT_BASE_DELAY_MS = 2000;
const ELECTRON_RECONNECT_MAX_DELAY_MS = 60000;
const ELECTRON_RECONNECT_MAX_EXPONENT = 5;
const ELECTRON_RECONNECT_MAX_ATTEMPTS = 10;
const lastSocketAlertAt = {};
const socketWasConnected = {};
let electronReconnectTimer = null;
let electronReconnectAttempt = 0;
let electronReconnectExhaustedNotified = false;

let url = "http://localhost:3001";

let socket_options = {
  reconnectionAttempts: 3,
  reconnectionDelay: 10000,
};

export async function getHardwareId() {
  try {
    let resp = await ElectronAppService.getHardwareId();
    const { data } = resp;
    console.log('getHardwareId data', data);
    if (data && data.status) {
      return data.data;
    }

    return null;
  } catch (err) {
    console.log("🚀 ~ file: init.js ~ line 24 ~ getHardwareId ~ err", err);
    return null;
  }
}

export async function getResourceUsageInfo() {
  try {
    let resp = await ElectronAppService.getResourceUsage();
    const { data } = resp;

    if (data && data.status) {
      console.log('getResourceUsageInfo >>>sdksjd', data);
      return data.data;
    }

    return null;
  } catch (err) {
    console.log(
      "🚀 ~ file: init.js ~ line 44 ~ getResourceUsageInfo ~ err",
      err
    );
    return null;
  }
}

export async function getEcrConfig() {
  try {
    let resp = await ElectronAppService.getEcrConfigFiles();
    const { data } = resp;

    if (data && data.status) {
      console.log('getEcrConfig >>>sdksjd', data);
      return data;
    }

    return {
      status: false
    };
  } catch (err) {
    console.log(
      "🚀 ~ file: init.js ~ line 44 ~ getResourceUsageInfo ~ err",
      err
    );
    return {
      status: false
    };
  }
}

function extractMacAddress(sys_info) {
  try {
    if (!sys_info || !sys_info.macAddress || typeof sys_info.macAddress !== "object") {
      return null;
    }
    const keys = Object.keys(sys_info.macAddress);
    if (!keys.length) return null;
    const entry = sys_info.macAddress[keys[0]];
    return entry && entry.mac ? entry.mac : null;
  } catch (err) {
    console.error("extractMacAddress failed", err);
    return null;
  }
}

function describeSocketError(err) {
  if (!err) return "unknown";
  if (typeof err === "string") return err;
  if (err.message) return err.message;
  if (err.description && err.description.message) return err.description.message;
  return String(err);
}

function notifyOperator(label, message) {
  if (label === "electron") return;
  const now = Date.now();
  if (
    lastSocketAlertAt[label] &&
    now - lastSocketAlertAt[label] < SOCKET_ALERT_THROTTLE_MS
  ) {
    return;
  }
  lastSocketAlertAt[label] = now;
  try {
    if (Vue.toasted && typeof Vue.toasted.show === "function") {
      Vue.toasted.show(message);
    }
  } catch (err) {
    console.error("socket alert toast failed", err);
  }
}

function getElectronReconnectDelay() {
  const exponent = Math.min(electronReconnectAttempt, ELECTRON_RECONNECT_MAX_EXPONENT);
  const base = ELECTRON_RECONNECT_BASE_DELAY_MS * Math.pow(2, exponent);
  const jitter = Math.floor(Math.random() * ELECTRON_RECONNECT_BASE_DELAY_MS);
  return Math.min(base + jitter, ELECTRON_RECONNECT_MAX_DELAY_MS);
}

function resetElectronReconnectBackoff() {
  electronReconnectAttempt = 0;
  electronReconnectExhaustedNotified = false;
  if (electronReconnectTimer) {
    clearTimeout(electronReconnectTimer);
    electronReconnectTimer = null;
  }
}

function scheduleElectronReconnect() {
  if (electronReconnectTimer) return;
  if (electronSocket && electronSocket.connected) {
    resetElectronReconnectBackoff();
    return;
  }
  if (electronReconnectAttempt >= ELECTRON_RECONNECT_MAX_ATTEMPTS) {
    if (!electronReconnectExhaustedNotified) {
      electronReconnectExhaustedNotified = true;
      console.error(
        "[socket:electron] giving up manual reconnect after " +
          ELECTRON_RECONNECT_MAX_ATTEMPTS +
          " attempts; socket.io auto-reconnect continues"
      );
      lastSocketAlertAt.electron = 0;
      notifyOperator(
        "electron",
        "Printer service unavailable. Please restart the Nuvio POS app."
      );
    }
    return;
  }
  const delay = getElectronReconnectDelay();
  console.warn(
    "[socket:electron] scheduling reconnect attempt " +
      (electronReconnectAttempt + 1) +
      " in " +
      delay +
      "ms"
  );
  electronReconnectTimer = setTimeout(() => {
    electronReconnectTimer = null;
    if (electronSocket && electronSocket.connected) {
      resetElectronReconnectBackoff();
      return;
    }
    electronReconnectAttempt += 1;
    reconnectElectronSocket();
  }, delay);
}

function handleSocketFailure(label, eventName, err) {
  const reason = describeSocketError(err);
  console.error("[socket:" + label + "] " + eventName + ": " + reason);
  if (label === "electron") {
    scheduleElectronReconnect();
    return;
  }
  notifyOperator(label, "Server connection lost. Retrying...");
}

function attachSocketSafetyHandlers(socket, label) {
  if (!socket || typeof socket.on !== "function") return;
  if (socket.__posSocketSafetyAttached) return;
  socket.__posSocketSafetyAttached = true;
  socket.on("error", function (err) {
    handleSocketFailure(label, "error", err);
  });
  socket.on("connect_error", function (err) {
    handleSocketFailure(label, "connect_error", err);
  });
  socket.on("connect_timeout", function (timeout) {
    handleSocketFailure(label, "connect_timeout", "timeout after " + timeout + "ms");
  });
  socket.on("reconnect_error", function (err) {
    console.warn("[socket:" + label + "] reconnect_error: " + describeSocketError(err));
  });
  socket.on("reconnect_failed", function () {
    handleSocketFailure(label, "reconnect_failed", "all reconnection attempts failed");
  });
  socket.on("reconnect", function (attempt) {
    console.log("[socket:" + label + "] reconnected after " + attempt + " attempt(s)");
    lastSocketAlertAt[label] = 0;
    if (label === "electron") {
      resetElectronReconnectBackoff();
    }
  });
  socket.on("connect", function () {
    const wasConnectedBefore = !!socketWasConnected[label];
    socketWasConnected[label] = true;
    lastSocketAlertAt[label] = 0;
    if (label === "electron") {
      resetElectronReconnectBackoff();
    }
    if (wasConnectedBefore) {
      notifyOperator(
        label,
        label === "electron"
          ? "Printer service reconnected."
          : "Server connection restored."
      );
    }
  });
  socket.on("disconnect", function (reason) {
    console.warn("[socket:" + label + "] disconnected: " + (reason || "unknown"));
    if (reason === "io client disconnect") return;
    notifyOperator(
      label,
      label === "electron"
        ? "Printer service disconnected. Reconnecting..."
        : "Server connection lost. Reconnecting..."
    );
  });
}

export const reconnectElectronSocket = () => {
  try {
    if (electronSocket && !electronSocket.connected) {
      console.log('Reconnecting....');
      electronSocket.connect({
        ...socket_options,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        transports: ["websocket"],
        upgrade: false
      });
    } else {
      console.log('no connected....', electronSocket);
    }
  } catch (err) {
    console.error("reconnectElectronSocket failed", err);
  }
}

const SOCKET_KEEPALIVE_MS = 60 * 1000;

// socket.io-client v2 does not retry on its own after "io server disconnect" (a cluster
// worker restarting or kicking the socket), so reconnect it by hand. Skip while the manager
// is already mid-reconnect so we never open a second parallel attempt.
function ensureSocketConnected(socket) {
  try {
    if (!socket || socket.connected) return;
    if (socket.io && socket.io.reconnecting) return;
    socket.connect();
  } catch (err) {
    console.error("ensureSocketConnected failed", err);
  }
}

let backendElectronSocketsWired = false;

export function initBackendAndElectronSocket(backendSocket, electronSocket) {
  try {
    if (backendElectronSocketsWired) return;
    if (!backendSocket || !electronSocket) {
      console.error("initBackendAndElectronSocket missing sockets");
      return;
    }
    backendElectronSocketsWired = true;

    attachSocketSafetyHandlers(electronSocket, "electron");
    attachSocketSafetyHandlers(backendSocket, "backend");

    electronSocket.on("connect", function() {
      try {
        console.log("connected to electron app. So send message to backend");
        backendSocket.emit("hardware-connected");
      } catch (err) {
        console.error("electron connect handler failed", err);
      }
    });

    electronSocket.on("disconnect", function(reason) {
      try {
        if (reason === "io server disconnect") {
          scheduleElectronReconnect();
        }
      } catch (err) {
        console.error("electron disconnect handler failed", err);
      }
    });

    backendSocket.on("connect", function() {
      try {
        if (electronSocket && electronSocket.connected) {
          backendSocket.emit("hardware-connected");
        }
      } catch (err) {
        console.error("backend connect handler failed", err);
      }
    });

    backendSocket.on("disconnect", function(reason) {
      try {
        if (reason === "io server disconnect") {
          setTimeout(() => ensureSocketConnected(backendSocket), 1000);
        }
      } catch (err) {
        console.error("backend disconnect handler failed", err);
      }
    });

    backendSocket.on("SOCKET_KEEP_ALIVE", function() {
      if (backendSocket.connected) {
        backendSocket.emit("SOCKET_KEEP_ALIVE_ACK");
      }
    });

    backendSocket.on("SOCKET_PONG", function() {});

    setInterval(() => {
      ensureSocketConnected(backendSocket);
      if (!electronReconnectTimer) {
        ensureSocketConnected(electronSocket);
      }
      if (backendSocket.connected) {
        backendSocket.emit("SOCKET_PING");
      }
    }, SOCKET_KEEPALIVE_MS);

    // Browsers throttle timers in hidden tabs and drop sockets while offline or asleep;
    // reconnect straight away when the screen comes back instead of waiting for the interval.
    const reconnectNow = () => {
      ensureSocketConnected(backendSocket);
      ensureSocketConnected(electronSocket);
    };
    window.addEventListener("online", reconnectNow);
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") reconnectNow();
    });

    backendSocket.on("ping-hardware", async function() {
      try {
        let hardware_id = await getHardwareId();
        let sys_info = await getResourceUsageInfo();
        let macAddress = extractMacAddress(sys_info);
        backendSocket.emit("hardware-ping-back", {
          hardware_id,
          sys_info,
          macAddress
        });
      } catch (err) {
        console.error("ping-hardware handler failed", err);
      }
    });

    backendSocket.on("get-hardware-id", async function() {
      try {
        let hardware_id = await getHardwareId();
        let sys_info = await getResourceUsageInfo();
        let macAddress = extractMacAddress(sys_info);
        if (macAddress) {
          window.localStorage.setItem("hardware_mac_address", macAddress);
        }
        let device = "POS";
        backendSocket.emit("hardware-id", hardware_id, device, macAddress);
      } catch (err) {
        console.error("get-hardware-id handler failed", err);
      }
    });

    backendSocket.on("get-system-info", async function() {
      try {
        let sys_info = await getResourceUsageInfo();
        backendSocket.emit("system-info", sys_info);
      } catch (err) {
        console.error("get-system-info handler failed", err);
      }
    });

    backendSocket.on("device-unique-code", async function(code) {
      try {
        console.log("device-unique-code", code);
        if (!code || typeof code !== "object") return;
        const { unique_code, hardware_name, hardware_mac_address } = code;
        if (unique_code != null) {
          window.localStorage.setItem("deiviceUniqueCode", unique_code);
          window.localStorage.setItem("HWUID", unique_code);
        }
        if (hardware_name != null) {
          window.localStorage.setItem("hardware_name", hardware_name);
        }
        if (hardware_mac_address != null) {
          window.localStorage.setItem(
            "hardware_mac_address",
            hardware_mac_address
          );
        }
      } catch (err) {
        console.error("device-unique-code handler failed", err);
      }
    });
  } catch (err) {
    console.error("initBackendAndElectronSocket failed", err);
  }
}



// WEBPACK FOOTER //
// ./src/socket.io/init.js